const INITIAL_STATE = {
  registro: {},
  modoTela: "lista",
  aguardando: false,
  lista: [],
  listaRetorno: [],
  resultadoEnvio: null,
  filtro: {
    id_sindicato_acesso: null,
    data: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "MENSALIDADE_MODO_TELA":
      return {
        ...state,
        modoTela: action.payload.modo,
      };

    case "MENSALIDADE_LISTADO":
      return {
        ...state,
        lista: action.payload.data,
      };
    case "MENSALIDADE_RETORNO_LISTADO":
      return {
        ...state,
        listaRetorno: action.payload.data,
      };

    case "MENSALIDADE_SET_FILTRO":
      return {
        ...state,
        filtro: action.payload,
        resultadoEnvio: null,
        lista: [],
        listaRetorno: [],
      };

    case "MENSALIDADE_SET_AGUARDANDO":
      return {
        ...state,
        aguardando: action.payload,
      };
    case "MENSALIDADE_SET_RESULTADO_ENVIO":
      return {
        ...state,
        resultadoEnvio: action.payload,
      };

    default:
      return state;
  }
};
